import React, { useRef } from "react";
import { useEffect } from "react";
import { Confirm, useGetOne, usePermissions } from "react-admin";
import EmployerDetails from "./EmployerDetails";
import DragDropDocumentButton from "../components/DragDropDocumentButton";
import ShowValidationMessages from "../components/ShowValidationMessages";
import ShowComments from "../components/ShowComments";
import YesNoRadioButton from "../../../componets/common/InputComponents/YesNoRadioButton";
import { useQueryClient } from 'react-query';
import NoDocReasonRadioButtons from "../../common/InputComponents/NoDocReasonRadioButtons";
import InputField2 from "../../common/InputComponents/InputField2";
import ShowDocumentStatus from "../components/ShowDocumentStatus";
import StatusComponent from "../components/StatusComponent";
import AddDocuverusComment from "../Modals/AddDocuverusComment";
import overa from "../../../assets/images/overa.svg";
import greenTick from "../../../assets/images/greenTick.svg";
import Card from "@mui/material/Card";
import { Alert, CardHeader } from "@mui/material";
import FormInstruction from "../../common/FormInstruction";
import DeleteContainedBtn from "../../common/DeleteContainedBtn";
import InputSelectField from "../../common/InputComponents/InputSelectField";
import { NumericFormat } from "react-number-format";
import InputCheckBoxField from "../../common/InputComponents/InputCheckBoxField";
import ShowValidationMessagesApplicant from "../components/ShowValidationMessagesApplicant";
import { DocumentSourceActionStrip } from "../documentMoveContext";

import SyncIcon from "@mui/icons-material/Sync";
import CustomPreviewUpload from "../../common/CustomPreviewUpload";
import FilePreview from "../../common/FilePreview";
import TextInputPhone from "../components/inputComponents/TextInputPhone";
import InputDateField from "../../common/InputComponents/InputDateFieldOld";
import InputCurrencyField from "../components/inputComponents/InputCurrencyField";
import AddDocuverusCommetApplicant from "../Modals/AddDocuverusCommetApplicant";
import { PayTile } from "../../Molecules/PayTile";
import AvgPay from "../../../utils/AvgPay";
import CalculateMonthlyNetPay from "../../../utils/CalculateMonthlyNetPay";
import CalculateMonthlyGrossPay from "../../../utils/CalculateMonthlyGrossPay";
import { calculateMonthlyPayFromAmount } from "../../../utils/CalculateMonthlyPay";
import { LookBackSatisfied } from "../../../utils/LookbackSatisfied";
import {
  useCreate,
  useNotify,
  useGetIdentity,
} from "react-admin";

const formatUploadRequirementText = (
  count?: number | null,
  unit: "week" | "month" = "week"
) => {
  const normalizedCount = Number(count) || 0;
  if (normalizedCount <= 0) return null;
  const normalizedUnit = `${unit}${normalizedCount === 1 ? "" : "s"}`;
  return `Upload paystubs covering the ${normalizedCount} most recent ${normalizedUnit}`;
};

const uploadActionPanelStyle: React.CSSProperties = {
  width: "240px",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const EmployerSource = ({
  field,
  index,
  mannualSOCRstatus,
  socrStatus,
  serEmployerNumber,
  setConfirmDeleteSource,
  methods,
  loadingdeleteEmployer,
  confirmDeleteSource,
  meta_d_response,
  IncomeAPIResponse,
  role,
  trn_id,
  handleDeleteEmployer,
  setButtonVisible, buttonVisible,
  getSrcfromStatus,
  getClassfromStatus,
  gettextStylefromStatus,
  refresh,
  adminValidationMessages,
  invitationType,
  handleAPIDebounced,
  filePreview,
  setFilePreview,
  collapse,
  setCollapse,
  handleReprocessEmployer,
  mlClassDetails,
  ...props
}) => {
  const notify = useNotify();
  const [create, { isLoading, error }] = useCreate();
  const { EmployerNumber } = field;
  const sourceNumber = Number(EmployerNumber) || index + 1;
  const queryClient = useQueryClient()
  const { permissions } = usePermissions();
  const shouldShowOfferLetterGuidance = role !== "Docuverus Super Admin";
  const normalizedRole = String(role || "").toLowerCase();
  const documentSourceId = field?.id ?? field?.source_id ?? null;
  const paystubUploadRequirementText = formatUploadRequirementText(
    props?.LookbacksData?.paystub_lookback,
    "week"
  );
  let statusValue = null;
  if (mannualSOCRstatus)
    statusValue = mannualSOCRstatus[`Source_${EmployerNumber}`]
      ? mannualSOCRstatus[`Source_${EmployerNumber}`]
      : socrStatus[`source_${EmployerNumber}`]?.SOCRStatus;

  const getNoofWeeksText = (look_back_period, no_of_weeks) => {
    return `${no_of_weeks} (required ${look_back_period})`;
  };
  const handleClick = async (e) => {
    e.preventDefault();
    notify("Bank verification has failed", {
      type: "error",
      anchorOrigin: { vertical: "top", horizontal: "right" },
    });
  };
  const handleToggle = (fieldId) => {
    setCollapse((prevOpenCollapsibles) => {
      if (prevOpenCollapsibles.includes(fieldId)) {
        // If the collapsible is already open, close it
        return prevOpenCollapsibles?.filter((id) => id !== fieldId);
      } else {
        // If the collapsible is closed, open it
        return [...prevOpenCollapsibles, fieldId];
      }
    });
  };
  const { watch, getValues, setValue } = methods;
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (
        type === "change" &&
        (name == `employer[${index}].pay_frequency` ||
          name == `employer.${index}.avrgross_pay`)
      ) {
        let _monthlyIncome = getValues(`employer.${index}.avrgross_pay`) || 0;
        const pay_frequency = getValues(
          `employer[${index}].pay_frequency`
        ).value;
        if (watch(`employer[${index}].pay_frequency`) !== "") {
          _monthlyIncome = calculateMonthlyPayFromAmount(
            _monthlyIncome,
            pay_frequency
          );
          setValue(`employer.${index}.total_income`, _monthlyIncome || 0);
          setValue(
            `employer.${index}.total_annual_income`,
            (_monthlyIncome || 0) * 12
          );
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [getValues, index, setValue, watch]);
  const intervalIdRef = useRef<NodeJS.Timeout | null>(null);


  const { data: validationCheck, isSuccess } = useGetOne("getEmployerValidationCheck", { id: trn_id }, { enabled: trn_id != null, refetchOnWindowFocus: true });
  return (
    <div className="pt-1">
      <div className="login-radio-types p-2">
        <div className="row pb-2">
          <div className="col-12">
            <Card
              sx={{
                background: "#f5fdff",
                boxShadow: "none",
                borderBottom: "1px solid black",
                borderRadius: 0,
              }}
            >
              <CardHeader
                sx={{ padding: 0 }}
                title={
                  <b style={{ fontSize: 13 }}>{`Employer ${sourceNumber
                    }: ${methods.watch(`employer.${index}.employer_name`)}`}</b>
                }
                action={
                  (
                    <DeleteContainedBtn
                      onClick={() => {
                        serEmployerNumber(field?.id);
                        setConfirmDeleteSource(true);
                      }}
                      disable={loadingdeleteEmployer}
                    />
                  )
                }
              />
            </Card>
            <Confirm
              isOpen={confirmDeleteSource}
              // loading={isLoading}
              sx={{
                "& .RaConfirm-iconPaddingStyle": {
                  display: "none",
                },
              }}
              title="Confirm"
              content="Are you sure you want to remove this employer?"
              onConfirm={() => handleDeleteEmployer()}
              onClose={() => {
                serEmployerNumber(0);
                setConfirmDeleteSource(false);
              }}
            />
          </div>
        </div>
        {field?.files &&
          field?.files.length > 0 &&
          (!!validationCheck?.other_check ||
            IncomeAPIResponse?.data?.employment_details?.SOCRstatus[
            `Source_${sourceNumber}`
            ]) &&
          role !== "applicant" ? (
          <div className="appl-status-wrap">
            {field?.employer_source_ocr_complete && isSuccess ? (
              <div className="d-flex flex-wrap ">
                <div className="pr-2 pt-2">
                  {role === "Docuverus Super Admin" ? (
                    <ShowDocumentStatus
                      label={"Overall"}
                      trn_id={trn_id}
                      documentId={3}
                      SourceId={sourceNumber}
                      value={
                        (IncomeAPIResponse?.data?.employment_details
                          ?.SOCRstatus &&
                          `Source_${sourceNumber}` in
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus &&
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus[`Source_${sourceNumber}`]) ||
                        validationCheck?.other_check[`source_${EmployerNumber}`]?.SOCRStatus

                      }
                      src={getSrcfromStatus(
                        (IncomeAPIResponse?.data?.employment_details
                          ?.SOCRstatus &&
                          `Source_${sourceNumber}` in
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus &&
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus[`Source_${sourceNumber}`]) ||
                        validationCheck?.other_check[`source_${EmployerNumber}`]?.SOCRStatus

                      )}
                      blockStyle={getClassfromStatus(
                        (IncomeAPIResponse?.data?.employment_details
                          ?.SOCRstatus &&
                          `Source_${sourceNumber}` in
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus &&
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus[`Source_${sourceNumber}`]) ||
                        validationCheck?.other_check[`source_${EmployerNumber}`]?.SOCRStatus

                      )}
                      className={"col-lg-3 col-sm-3 col-3"}
                      textStyle={gettextStylefromStatus(
                        (IncomeAPIResponse?.data?.employment_details
                          ?.SOCRstatus &&
                          `Source_${sourceNumber}` in
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus &&
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus[`Source_${sourceNumber}`]) ||
                        validationCheck?.other_check[`source_${EmployerNumber}`]?.SOCRStatus

                      )}
                      // invalidateQueries={["income", "getEmployerValidationCheck"]}
                      invalidateQueries={
                        "income"
                      }
                    />
                  ) : (
                    <ShowDocumentStatus
                      label={"Overall"}
                      trn_id={trn_id}
                      documentId={3}
                      SourceId={sourceNumber}
                      src={getSrcfromStatus(
                        (IncomeAPIResponse?.data?.employment_details
                          ?.SOCRstatus &&
                          `Source_${sourceNumber}` in
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus &&
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus[`Source_${sourceNumber}`]) ||
                        validationCheck?.other_check[`source_${EmployerNumber}`]?.SOCRStatus

                      )}
                      blockStyle={getClassfromStatus(
                        (IncomeAPIResponse?.data?.employment_details
                          ?.SOCRstatus &&
                          `Source_${sourceNumber}` in
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus &&
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus[`Source_${sourceNumber}`]) ||
                        validationCheck?.other_check[`source_${EmployerNumber}`]?.SOCRStatus

                      )}
                      className={"col-lg-3 col-sm-3 col-3"}
                      textStyle={gettextStylefromStatus(
                        (IncomeAPIResponse?.data?.employment_details
                          ?.SOCRstatus &&
                          `Source_${sourceNumber}` in
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus &&
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus[`Source_${sourceNumber}`]) ||
                        validationCheck?.other_check[`source_${EmployerNumber}`]?.SOCRStatus

                      )}
                      // invalidateQueries={["income", "getEmployerValidationCheck"]}

                      disable={true}
                      value={
                        (IncomeAPIResponse?.data?.employment_details
                          ?.SOCRstatus &&
                          `Source_${sourceNumber}` in
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus &&
                          IncomeAPIResponse?.data?.employment_details
                            ?.SOCRstatus[`Source_${sourceNumber}`]) ||
                        validationCheck?.other_check[`source_${EmployerNumber}`]?.SOCRStatus
                      }
                      customWidth={150}
                      invalidateQueries={
                        "income"
                      }
                    />
                  )}
                </div>
                <div className="px-2 pt-2">
                  <StatusComponent
                    blockStyle={""}
                    label={"Name Matched"}
                    validationIcon={
                      validationCheck?.other_check[`source_${EmployerNumber}`]?.name_match == true
                        ? greenTick
                        : overa
                    }
                    validationText={
                      validationCheck?.other_check[`source_${EmployerNumber}`]?.name_match == null
                        ? "NA"
                        : validationCheck?.other_check[
                          `source_${sourceNumber}`
                        ]?.name_match == true
                          ? "Yes"
                          : "No"
                    }
                    validationTextStyle={
                      validationCheck?.other_check[`source_${EmployerNumber}`]?.name_match == true
                        ? "green-stat"
                        : "brown-stat"
                    }
                  />
                </div>
                <div className="px-2 pt-2">
                  <StatusComponent
                    blockStyle={""}
                    label={"Current"}
                    validationIcon={
                      validationCheck?.other_check[`source_${EmployerNumber}`]?.current == true
                        ? greenTick
                        : overa
                    }
                    validationText={
                      validationCheck?.other_check[`source_${EmployerNumber}`]?.current == null
                        ? "NA"
                        : validationCheck?.other_check[`source_${EmployerNumber}`]?.current == true
                          ? "Yes"
                          : "No"
                    }
                    validationTextStyle={
                      validationCheck?.other_check[`source_${EmployerNumber}`]?.current == true
                        ? "green-stat"
                        : "brown-stat"
                    }
                  />
                </div>
                <div className="px-2 pt-2">
                  <StatusComponent
                    blockStyle={""}
                    label={"Consecutive"}
                    validationIcon={
                      validationCheck?.other_check[`source_${EmployerNumber}`]?.concurrent
                        ? greenTick
                        : overa
                    }
                    validationText={
                      validationCheck?.other_check[`source_${EmployerNumber}`]?.concurrent == null
                        ? "NA"
                        : validationCheck?.other_check[`source_${EmployerNumber}`]?.concurrent == true
                          ? "Yes"
                          : "No"
                    }
                    validationTextStyle={
                      validationCheck?.other_check[`source_${EmployerNumber}`]?.concurrent
                        ? "green-stat"
                        : "brown-stat"
                    }
                  />
                </div>
                <div className="px-2 pt-2">
                  <div className={`block`}>
                    <div style={{ fontSize: '12px', lineHeight: '16px', textAlign: 'center' }}>No. of Weeks</div>
                    <img
                      src={
                        parseInt(
                          validationCheck?.other_check[
                            `source_${sourceNumber}`
                          ]?.no_of_weeks
                        ) >=
                          parseInt(
                            validationCheck?.other_check[
                              `source_${sourceNumber}`
                            ]?.look_back_period
                          )
                          ? greenTick
                          : overa
                      }
                      alt=""
                    />
                    <span
                      style={{
                        fontSize: "12px",
                        lineHeight: "16px",
                        textAlign: "center",
                      }}
                    >
                      {getNoofWeeksText(
                        validationCheck?.other_check[
                          `source_${sourceNumber}`
                        ]?.look_back_period,
                        validationCheck?.other_check[
                          `source_${sourceNumber}`
                        ]?.no_of_weeks
                      )}
                    </span>
                  </div>
                </div>
                <div className="px-2 pt-2">
                  <PayTile lookBackPeriodSatisfied={LookBackSatisfied({
                    uploadedLookBackPeriod: validationCheck?.other_check[`source_${sourceNumber}`]?.no_of_weeks,
                    requiredLookbackPeriod: validationCheck?.other_check[
                      `source_${sourceNumber}`
                    ]?.look_back_period
                  })} title="Monthly Gross Pay" payAmt={AvgPay(CalculateMonthlyGrossPay(methods.watch(`employer.${index}.files`)), methods.watch(`employer.${index}.files`))} />
                </div>
                <div className="px-2 pt-2">
                  <PayTile lookBackPeriodSatisfied={LookBackSatisfied({
                    uploadedLookBackPeriod: validationCheck?.other_check[`source_${sourceNumber}`]?.no_of_weeks,
                    requiredLookbackPeriod: validationCheck?.other_check[
                      `source_${sourceNumber}`
                    ]?.look_back_period
                  })} payAmt={AvgPay(CalculateMonthlyNetPay(methods.watch(`employer.${index}.files`)), methods.watch(`employer.${index}.files`))} />
                </div>

              </div>
            ) : (
              <div className="d-flex align-item-center">
                <FormInstruction message={"Document under Processing"} />
                <button
                  type="button"
                  onClick={() => refresh()}
                  className="btn btn-sm btn-outline-primary"
                >
                  <SyncIcon sx={{ fontSize: 12 }} /> Refresh
                </button>
              </div>
            )}
            {/* </div> */}
          </div>
        ) : null}
        {field?.files &&
          field?.files?.length > 0 &&
          field?.employer_source_ocr_complete &&
          role !== "applicant" && isSuccess ? (
          <>

            <ShowValidationMessages
              role={role === "applicant" ? "applicant" : role}
              validation_message={
                validationCheck?.validation_messages[`source_${EmployerNumber}`]?.map(item => item.admin)?.filter(item => item?.message && (role === "Docuverus Super Admin" || !item.isDeleted))
                // adminValidationMessages?.[`Source_${EmployerNumber}`]
              }
              fetchRecord={() => null}
              trn_id={trn_id}
              source_id={EmployerNumber}
              section={"Employment"}
              invalidateQueries={"getEmployerValidationCheck"}
              tag={`updateValidationMessages_employment`}
              document_id={3}

            />

            <ShowValidationMessages
              role={role === "applicant" ? "applicant" : role}
              validation_message={
                validationCheck?.validation_messages[`source_${EmployerNumber}`]?.map(item => item?.applicant)?.filter(item => item?.message && (role === "Docuverus Super Admin" || !item?.isDeleted))
                // adminValidationMessages?.[`Source_${EmployerNumber}`]
              }
              isApplicantTitle={true}
              fetchRecord={() => null}
              trn_id={trn_id}
              source_id={EmployerNumber}
              section={"Employment"}
              invalidateQueries={"getEmployerValidationCheck"}
              tag={`updateValidationMessages_employment`}
              document_id={3}

            />
          </>
        ) : null}

        {role === "Docuverus Super Admin"
          // (field?.Internal == true ? permissions?.includes('view_internal_comments') : true)
          &&
          <span className="print-hide"><ShowComments
            section_comment={field?.Internal_comment}
            comment_heading="Docuverus Internal Comment"
            role={role === "applicant" ? "applicant" : role}
          /></span>}
        {<ShowComments
          section_comment={field?.section_comment}
          role={role === "applicant" ? "applicant" : role}
        />}
        {field?.section_comment['applicant'] !== "" &&
          <ShowComments
            section_comment={field?.section_comment}
            role={role === "applicant" ? "applicant" : role}
            comment_heading="Applicant Comment"
          />}
        {/*  */}
        {invitationType == "1" ? (
          <div className="mr-t20 bullet-style">
            <YesNoRadioButton
              required={props.required}
              label={
                "Do you have proof of employment income available to upload?"
              }
              source={`employer.${index}.availableToUpload`}
              disable={methods?.getValues()?.employer[index]?.fileCount}

            />
          </div>
        ) : (
          ""
        )}
        {/* <div className="login-radio-types p-2"> */}
        {invitationType == "1" &&
          methods?.watch()?.employer[index]?.availableToUpload == "No" && (
            <>
              {/* <div> */}
              <div className="login-radio-types p-2">
                <NoDocReasonRadioButtons
                  handleOnchange={() => {
                    handleAPIDebounced();
                  }}
                  source={`employer.${index}.no_doc_reason`}
                  options={[
                    {
                      name: "I don't currently have access to document(s), but can provide later",
                      value:
                        "I don't currently have access to document(s), but can provide later",
                    },
                    {
                      name: "I do not have proof of employment",
                      value: "I do not have proof of employment",
                    },
                    {
                      name: "Other",
                      value: "Other",
                    },
                  ]}
                  section_id={4}
                />
                {methods.watch(`employer.${index}.no_doc_reason`) ==
                  "Other" && (
                    <div className="col-12 col-md-4 col-lg-4 mr-t20 mr-l30 mr-b10">
                      <InputField2

                        source={`employer.${index}.other_reason`}
                        label={"Other reason"}
                        placeholder=""
                      />
                    </div>
                  )}
              </div>
            </>
          )}
        {/*  */}

        <div className="row align-items-center">
          {(invitationType == "1" &&
            methods?.watch()?.employer[index]?.availableToUpload == "Yes") ||
            invitationType !== "1" ? (
            <>
              <div className="row">
                <div
                  className={
                    filePreview.proof_of_income !== ""
                      ? `col-md-8 col-sm-12 px-4 card-body pt-2`
                      : ` px-4 card-body pt-2`
                  }
                >
                  <div
                    className="col-sm-12 col-md-12 mt-2"
                    style={{
                      fontSize: "12px",
                      color: "#111827",
                      paddingLeft: "16px",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <strong>
                        Proof of Employment Income :*
                      </strong>
                    </div>
                    <p className="mb-1 mt-1" style={{ paddingLeft: "10px" }}>
                      Uploading <strong>ORIGINAL</strong> PDF pay stubs from your payroll provider (photos and
                      screenshots are <strong>NOT</strong> accepted).
                    </p>
                    <div className="mt-1">
                      <InputCheckBoxField
                        notRequired={true}
                        name={`employer.${index}.allowOfferLetter`}
                        label="Offer letter (for new jobs only)"
                      />
                    </div>
                    {shouldShowOfferLetterGuidance && (
                      <Alert
                        severity="info"
                        sx={{
                          mt: 1,
                          ml: "10px",
                          fontSize: 12,
                          alignItems: "flex-start",
                        }}
                      >
                        <ul style={{ margin: 0, paddingLeft: "18px" }}>
                          <li>
                            Only upload an offer letter if your job hasn&apos;t
                            started yet or started less than 2 weeks ago.
                          </li>
                          <li>
                            If uploading an offer letter, upload bank statements
                            in the Banking section below, not here.
                          </li>
                          <li>
                            If this is a recent job change, click &quot;Add
                            another employer&quot; to add your previous employer
                            and upload pay stubs there.
                          </li>
                        </ul>
                      </Alert>
                    )}
                  </div>
                  <div className="col-md-12 col-sm-12 mt-2">
                    <div className="d-flex flex-wrap align-items-start">
                      <div
                        className="mb-2 me-2"
                        style={uploadActionPanelStyle}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <DragDropDocumentButton
                            SourceId={documentSourceId}
                            documentId={"3"}
                            helperText={paystubUploadRequirementText || undefined}
                            fetchRecord={() => null}
                            allowOfferLetter={watch(
                              `employer.${index}.allowOfferLetter`
                            )}
                            acceptedFiles={"application/pdf"}
                            invalidateQueries={"income"}
                            tag={"IncomeUpload"}
                            trn_id={trn_id}
                            fileError={
                              methods.formState?.errors?.employer?.[
                                EmployerNumber - 1
                              ] && role === "applicant"
                                ? true
                                : false
                            }
                            notifyMessage={
                              "Supported file format is pdf files only."
                            }
                          />
                          <DocumentSourceActionStrip
                            scope={{ sectionKey: "paystub", sourceId: documentSourceId, sourceIndex: index }}
                            documents={(field?.files || []).map((item) => ({
                              id: String(item?.application_document_id),
                              source: { sectionKey: "paystub", sourceId: documentSourceId, sourceIndex: index },
                              documentType: 3,
                              isOfferLetter: Boolean(item?.isOfferLetter || /offer\s*letter/i.test(item?.file_name || "")),
                              label: item?.file_name,
                            }))}
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-wrap align-items-start">
                        {field?.files?.map((item, i) => {
                          const fileKey =
                            item?.application_document_id ??
                            `${item?.file_name || "file"}-${i}`;
                          return (
                            <div
                              className="px-1"
                              key={fileKey}
                            >

                              <FilePreview
                                source_index={index}
                                source_name={"paystub"}
                                sourceId={documentSourceId}
                                file_name={item?.file_name}
                                doc_id={item?.application_document_id}
                                img={item?.path_image}
                                createdAt={item?.created_on}
                                showReprocess={true}
                                isOfferLetter={!!item?.isOfferLetter}
                                tag={"delete_document_other_income"}
                                invalidateQueries={"otherIncomeDoc"}
                                is_Duplicate={item?.is_Duplicate}
                                file={item?.path}
                                handleClick={() =>
                                  setFilePreview({
                                    ...filePreview,
                                    proof_of_income: item?.application_document_id,
                                    proof_of_income_filePath: item?.path,
                                    proof_of_income_fileName: item?.file_name,
                                    startpage: item?.startpage,
                                    id: field?.fieldId,
                                  })
                                }
                              />
                            </div>
                          );
                        })}
                      </div>

                    </div>
                  </div>
                </div>
                {field?.files?.findIndex(
                  (file) =>
                    file?.application_document_id === filePreview?.proof_of_income
                ) !== -1 &&
                  filePreview?.proof_of_income !== "" &&
                  filePreview?.id == field?.fieldId && (
                    <div className="col-md-4 col-sm-12 mt-2">
                      <CustomPreviewUpload
                        filePath={filePreview?.proof_of_income_filePath}
                        startpage={filePreview?.startpage}
                      />
                    </div>
                  )}
              </div>
            </>
          ) : (
            ""
          )}

          {(role === "applicant" && isSuccess) && (
            <>
              <div className="col-12">
                {
                  <ShowValidationMessagesApplicant validation_message={validationCheck?.validation_messages[`source_${EmployerNumber}`]?.filter(item => item?.applicant && !item?.applicant?.isDeleted)?.map(item => item?.applicant)} />

                }
              </div>
            </>
          )}
          {role !== "applicant" && (
            <>
              <div className="expand-heads d-flex print-hide">
                <button
                  className="ml-auto print-hide"
                  type="button"
                  onClick={() => handleToggle(field?.id)}
                >
                  Expand for Details
                  {/* {collapse == field.id ? ( */}
                  {collapse.includes(field?.id) ? (
                    <span>
                      <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.00001 2.21856L1.70001 5.51856L0.757341 4.57589L5.00001 0.333222L9.24268 4.57589L8.30001 5.51855L5.00001 2.21856Z"
                          fill="#2DC3E8"
                        />
                      </svg>
                    </span>
                  ) : (
                    <span>
                      <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.99999 3.78047L8.29999 0.480469L9.24266 1.42314L4.99999 5.6658L0.757324 1.42314L1.69999 0.480469L4.99999 3.78047Z"
                          fill="#2DC3E8"
                        />
                      </svg>
                    </span>
                  )}
                </button>
              </div>

              <div
                style={{
                  display: collapse.includes(field?.id) ? "block" : "none",
                }}
                className="collapse cust-coll-appl print-hide"
                id={`app-det-coll${field?.id}`}
              >
                <div className="row align-items-center">
                  <div className="col-12 col-md-4 col-lg-4">
                    <InputField2

                      type="text"
                      label="Employer Name"
                      placeholder={""}
                      source={`employer.${index}.employer_name`}
                      notRequired={true}
                    />
                  </div>
                  {invitationType == "1" && (
                    <>
                      <div className="col-12 col-md-4 col-lg-4">
                        <InputField2

                          type="text"
                          label="Position"
                          placeholder={""}
                          source={`employer.${index}.position`}
                          notRequired={true}
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4">
                        <TextInputPhone
                          source={`employer.${index}.phone_no`}
                          label={`Employer Phone Number`}
                          isCountryCode={`employer.${index}.country_code`}
                          labelClass={"lable-title"}
                          additionalInputClass={"cus-control"}
                          widthClass={"w-100"}
                          requiredClass={{
                            fontSize: "70%",
                          }}

                          required={false}
                        />
                      </div>
                    </>
                  )}
                  <div className="col-12 col-md-8 col-lg-8">
                    <InputField2

                      type="text"
                      placeholder={""}
                      label="Address"
                      source={`employer.${index}.employer_address`}
                      notRequired={true}
                    />
                  </div>
                  <div className="col-12 col-md-4 col-lg-4">
                    <InputField2

                      type="text"
                      placeholder={""}
                      label="City"
                      source={`employer.${index}.employer_city`}
                      notRequired={true}
                    />
                  </div>
                  <div className="col-12 col-md-4 col-lg-4">
                    <InputSelectField
                      label={`State`}
                      stopAutoFocus={true}
                      source={`employer.${index}.employer_state`}
                      options={IncomeAPIResponse?.data?.States?.map((item) => ({
                        value: item?.ID || index,
                        label: item?.StateShortCode + " - " + item?.StateName,
                      }))}
                      labelAsteriskClass={"color-red"}
                      labelClass={"lable-title"}
                      requiredClass={{
                        fontSize: "70%",
                      }}

                      required={false}
                    />
                  </div>
                  <div className="col-12 col-md-4 col-lg-4">
                    <InputField2

                      type="number"
                      placeholder={""}
                      label="Zip Code"
                      source={`employer.${index}.employer_zipcode`}
                      notRequired={true}
                    />
                  </div>
                  {/*  */}
                  {invitationType == "1" && (
                    <>
                      <div className="col-12 col-md-4 col-lg-4">
                        <InputField2

                          type="text"
                          label="Manager Name"
                          placeholder={""}
                          source={`employer.${index}.manager_name`}
                          notRequired={true}
                        />
                      </div>
                      <div className="col-12">
                        <div className="row">
                          {methods.watch(
                            `employer.${index}.isfuture_employer`
                          ) == false && (
                              <div className="col-sm-12 col-md-6 col-lg-4 d-flex justify-content-between align-items-center">
                                <InputCheckBoxField
                                  notRequired={true}
                                  checked={methods.watch(
                                    `employer.${index}.iscurrent_employer`
                                  )}
                                  label="Is this current employer?"
                                  name={`employer.${index}.iscurrent_employer`}

                                />
                              </div>
                            )}
                          {methods.watch(
                            `employer.${index}.iscurrent_employer`
                          ) == false && (
                              <div className="col-sm-12 col-md-6 col-lg-4 d-flex justify-content-between align-items-center">
                                <InputCheckBoxField
                                  notRequired={true}
                                  checked={methods.watch(
                                    `employer.${index}.isfuture_employer`
                                  )}
                                  label="Is this future employer?"
                                  name={`employer.${index}.isfuture_employer`}

                                />
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row">
                          <div className="col-12 col-md-4 col-lg-4">
                            <InputSelectField
                              label={`Employment Status`}
                              source={`employer[${index}].employer_status`}
                              options={[
                                {
                                  value: "Employed Full-Time",
                                  label: "Employed Full-Time",
                                },
                                {
                                  value: "Employed Part-Time",
                                  label: "Employed Part-Time",
                                },
                              ]}
                              labelAsteriskClass={"color-red"}
                              stopAutoFocus={true}
                              labelClass={"lable-title"}
                              requiredClass={{
                                fontSize: "70%",
                              }}

                              required={false}
                            />
                          </div>
                          <div className="col-12 col-md-4 col-lg-4">
                            <InputDateField
                              source={`employer.${index}.employment_start_date`}
                              label="Employment Start Date"
                              labelClass={"lable-title"}

                              notRequired={true}
                            />
                          </div>
                          {methods.watch(
                            `employer.${index}.iscurrent_employer`
                          ) === false &&
                            methods.watch(
                              `employer.${index}.isfuture_employer`
                            ) === false && (
                              <div className="col-sm-12 col-md-6 col-lg-4">
                                <div className="form-group cus-input-group mr-b20">
                                  <InputDateField
                                    source={`employer.${index}.employment_end_date`}
                                    label="Employment End Date"
                                    labelClass={"lable-title"}

                                    notRequired={true}
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-lg-4">
                        <InputCurrencyField
                          label="Gross Pay (Pre Tax)"
                          source={`employer.${index}.avrgross_pay`}
                          required={false}
                          labelClass={"lable-title"}
                          requiredClass={{
                            fontSize: "70%",
                          }}

                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4">
                        <InputCurrencyField
                          disabled={true}
                          label="According to document Gross Pay (Pre Tax)"
                          source={`employer.${index}.monthly_avr_gross`}
                          required={false}
                          labelClass={"lable-title"}
                          requiredClass={{
                            fontSize: "70%",
                          }}
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4">

                        <InputSelectField
                          label={`Pay Frequency (of the amt entered)`}
                          source={`employer[${index}].pay_frequency`}
                          options={[
                            {
                              label: "Weekly",
                              value: "Weekly",
                            },
                            {
                              label: "Bi-Weekly",
                              value: "Bi-Weekly",
                            },
                            {
                              label: "Monthly",
                              value: "Monthly",
                            },
                            {
                              label: "Bi-Monthly",
                              value: "Bi-Monthly",
                            },
                            {
                              label: "One-Time",
                              value: "One-Time",
                            },
                            {
                              label: "Yearly",
                              value: "Yearly",
                            },
                          ]}
                          labelAsteriskClass={"color-red"}
                          labelClass={"lable-title"}
                          stopAutoFocus={true}
                          requiredClass={{
                            fontSize: "70%",
                          }}

                          required={false}
                        />
                      </div>
                      <div className="col-12 col-md-4 col-lg-4">
                        <div className="incom-info-block">
                          <h4>
                            <span
                              style={{
                                marginTop: "-6px",
                                marginBottom: "-5px",
                              }}
                              className="lable-title"
                            >
                              Calculated Amounts:
                            </span>
                          </h4>
                          <div className="row">
                            <div className="col-8 small">
                              Yearly Gross Income:
                            </div>
                            <div className="col">
                              <NumericFormat
                                decimalScale={2}
                                value={methods.watch(
                                  `employer.${index}.total_annual_income`
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-8 small">
                              {" "}
                              Monthly Gross Income:
                            </div>
                            <div className="col">
                              <NumericFormat
                                decimalScale={2}
                                value={methods.watch(
                                  `employer.${index}.total_income`
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/*  */}
                  {(invitationType == "1" &&
                    methods?.watch()?.employer[index]?.availableToUpload ==
                    "Yes") ||
                    (invitationType !== "1") ? (
                    <>
                      {role !== "Applicant" &&
                        role !== "applicant" &&
                        (
                          <>
                            <div className="d-flex justify-content-center">
                              <div className="border-top mt-3 w-100"></div>
                            </div>
                            {/* <div className="col-12 col-md-4 col-lg-4 mt-2">
                              <InputSelectField
                                onChangeCallback={() =>
                                  handleReprocessEmployer(index, field.id)
                                }
                                stopAutoFocus={true}
                                required={false}
                                label={`Reprocess Employer`}
                                source={`employer.${index}.correctedDocType`}
                                options={mlClassDetails}
                              />
                            </div> */}

                            <div className="col-12 col-md-4 col-lg-4"></div>
                            <div className="col-12 col-md-4 col-lg-4"></div>
                          </>
                        )}
                    </>
                  ) : (
                    ""
                  )}
                  {(invitationType == "1" &&
                    methods?.watch()?.employer[index]?.availableToUpload ==
                    "Yes") ||
                    invitationType !== "1" ? (
                    <>
                      <EmployerDetails
                        role={role}
                        sourceEmpField={field}
                        sourceEmpIndex={index}
                        mlClassDetails={mlClassDetails}
                        trn_id={trn_id}
                        setError={(fieldName, errObj, focusObj) => {
                          //
                          methods.setError(
                            fieldName,
                            { ...errObj },
                            { ...focusObj }
                          );
                        }}
                        handleOnChange={() => {
                          handleAPIDebounced();
                        }}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </>
          )}
          {role === "applicant" && <div className="col-12">
            <div className="d-flex justify-content-end">
              <AddDocuverusCommetApplicant
                label={
                  `Add Comment`
                }
                title={`Add Comment`
                }
                defaultValue={
                  IncomeAPIResponse?.data?.employment_details?.employer[index]?.section_comment?.applicant
                }
                trn_id={trn_id}
                is_applicant={role === "applicant" ? true : false}
                document_id={3}
                tag={"addComment_income"}
                invalidateQueries={"income"}
                emp_id={field?.id}
                role={role === "applicant" ? "applicant" : role}
              />
            </div>
          </div>}
          {role !== "applicant" && <div className="col-12">
            <div className="d-flex justify-content-end">
              <AddDocuverusComment
                label={
                  role === "applicant"
                    ? `Add Comment`
                    : "Add Docuverus Comment"
                }
                title={
                  role === "applicant"
                    ? `Add Comment`
                    : "Add/Edit Docuverus Comment"
                }
                defaultValue={
                  IncomeAPIResponse?.data?.employment_details?.employer[index]?.section_comment?.admin
                    ? IncomeAPIResponse?.data?.employment_details?.employer[index]?.section_comment?.admin
                    : ""
                }
                defaultValueInternal={IncomeAPIResponse?.data?.employment_details?.employer[index]?.Internal_comment?.admin}
                trn_id={trn_id}
                is_applicant={role === "applicant" ? true : false}
                document_id={3}
                tag={"addComment_income"}
                invalidateQueries={"income"}
                emp_id={field?.id}
                role={role === "applicant" ? "applicant" : role}
              />
            </div>
          </div>}
        </div>
      </div>

    </div>
  );
};

export default EmployerSource;
